<template>
  <div class="courseTable">

    <div class="filter">
      <p>请选择周数：</p>
      <span v-if="initWeek && maxWeekNum && minWeekNum">
        <counter @valueChange="weekChange" :initVal="initWeek" :max="maxWeekNum" :min="minWeekNum"></counter>
      </span>
      <button v-if="false">查询</button>
    </div>

    <div class="courseTableContainer">
      <table class="outer">
        <tr class="week">
          <td colspan="2"></td>
          <td :class="{'active':dayCourseList.date===coursePayload.dateStr}"
              v-for="(dayCourseList,index) in courseInfo">{{weekArr[index]}}
          </td>
        </tr>
        <tr>
          <td rowspan="4" class="step">上午</td>
          <td class="stepnu">1</td>
        </tr>
        <tr>
          <td class="stepnu">2</td>
        </tr>
        <tr>
          <td class="stepnu">3</td>
        </tr>
        <tr>
          <td class="stepnu">4</td>
        </tr>
        <tr>
          <td rowspan="4" class="step">下午</td>
          <td class="stepnu">5</td>
        </tr>
        <tr>
          <td class="stepnu">6</td>
        </tr>
        <tr>
          <td class="stepnu">7</td>
        </tr>
        <tr>
          <td class="stepnu">8</td>
        </tr>
        <tr>
          <td rowspan="4" class="step">晚上</td>
          <td class="stepnu">9</td>
        </tr>
        <tr>
          <td class="stepnu">12</td>
        </tr>
        <tr>
          <td class="stepnu">11</td>
        </tr>
        <tr>
          <td class="stepnu">12</td>
        </tr>

      </table>
      <div v-if="courseInfo.length" class="inner innerBack">
        <ul v-for="dayCourseList in 7" class="day">
          <li v-for="item in 12"></li>
        </ul>
      </div>
      <div v-if="courseInfo.length" class="inner innerMain">
        <ul v-for="dayCourseList in courseInfo" class="day"
            :class="{'active':dayCourseList.date===coursePayload.dateStr}">
          <li :style="getCourseItemHeight(course.qsj,course.jsj)" v-if="course"
              :class="{'vaild':course.kcmc,'half':course.xs==='1'}"
              v-for="course in dayCourseList.list">
            <span v-if="course  && !isSmallCourse(course)">
              <span class="date">{{course.skrq}}</span>
              <div class="kcmc">{{course.kcmc}}</div>
              <p>{{course.skdd}}</p>
            </span>
            <span v-if="course && isSmallCourse(course)">
              <small-scroll :courseData="course"></small-scroll>
            </span>

          </li>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>
  //axios
  import axios from 'axios'
  import apiConfig from 'common/js/api_config'
  //计数器
  import counter from 'components/globalComp/counter'
  //小课滚动组件
  import smallScroll from 'components/course/smallScroll'

  function padLeftZero(str) {
    str += "";
    return ('00' + str).substr(str.length);
  }

  export default {
    name: "courseTable",
    data() {
      return {
        weekArr: ['一', '二', '三', '四', '五', '六', '日'],
        courseInfo: [],
        courseDataOrigin: [],
        mondyDate: null,
        weeksData: [],
        initWeek: null,
        maxWeekNum: null,
        minWeekNum: null,
      }
    },
    props: {
      coursePayload: {
        type: Object,
      }
    },
    computed: {},
    components: {
      counter, smallScroll
    },
    methods: {
      initDataModel(date) {
        if (!date) {
          date = this.coursePayload.dateStr
        }
        let weekArr = this.getWeekArrByOneDate(new Date(date))
        this.mondyDate = weekArr[0]
        this.createWeekList(weekArr)
      },
      isSmallCourse(courseData) {
        if (!courseData.qsj || !courseData.jsj) {
          return false
        }
        let qsj = parseInt(courseData.qsj)
        let jsj = parseInt(courseData.jsj)

        let courseLength = jsj - qsj
        if (!courseLength) {
          return true
        }
        return false
      },
      async _initCourseData() {

        let courseData = await axios.post(apiConfig.REQUEST_URL + '/shall/front_getCourseDetailList?' + this.$qs.stringify({
          day: this.mondyDate,
          num: 7
        }))
        this.courseDataOrigin = courseData.data.data
        //将源端数据插入到前端数据模型
        this.insertDataByOriginData()

      },

      //将源端数据插入到前端数据模型
      insertDataByOriginData() {
        this.courseDataOrigin.forEach((originItem, index) => {
          this.insertCourseToDesignList(originItem)
        })
      },

      //将源端某一条数据插入既定模型
      insertCourseToDesignList(item) {
        let couData = this.courseInfo;
        for (let i = 0; i < couData.length; i++) {
          if (couData[i].date === item.skrq) {
            console.log(couData[i].date + ':' + item.skrq)
            couData[i].list[parseInt(item.qsj) - 1] = item
            couData[i].list.sort()
            break
          }
        }

      },


      createWeekList(weekArr) {
        let ret = []
        weekArr.forEach((dateStr, index) => {
          ret.push({
            date: dateStr,
            list: this.createDefaultCourse()
          })
        })
        this.courseInfo = ret
      },

      createDefaultCourse() {
        let ret = []
        for (let i = 0; i < 12; i++) {
          ret.push({})
        }
        return ret
      },

      //通过某一天获取当前周
      getWeekArrByOneDate(dateObj) {
        // debugger
        let y = dateObj.getFullYear();
        let m = dateObj.getMonth();
        let d = dateObj.getDate();
        let week = dateObj.getDay() - 1;
        if (week === -1) {
          week = 6
        }
        let surplus = 7 - week;
        let weekArr = [];
        for (let i = d - week; i < d + surplus; i++) {
          weekArr.push(this.getCalendarUnitByDateObj(new Date(y, m, i)))
        }
        console.log(weekArr)
        return weekArr;
      },

      getCalendarUnitByDateObj(dateObj) {
        return `${dateObj.getFullYear()}-${padLeftZero(dateObj.getMonth() + 1)}-${padLeftZero(dateObj.getDate())}`
      },
      //获取高度
      getCourseItemHeight(qsj, jsj) {
        qsj = parseInt(qsj)
        jsj = parseInt(jsj)
        const HEIGHT = 8.3
        let offsetCount = jsj - qsj + 1
        return `height:${offsetCount * HEIGHT}%;top:${(qsj - 1) * HEIGHT}%`
      },
      async _initWeeks() {
        let weeks = await axios.post(apiConfig.REQUEST_URL + '/shall/front_getCourseWeekList')
        if (weeks.data.status) {
          let weeksList = weeks.data.data
          this.weeksData = weeksList
          this.maxWeekNum = parseInt(weeksList[weeksList.length - 1].week)
          this.minWeekNum = parseInt(weeksList[0].week)
        }
        this.initWeek = parseInt(this.getWeekInfo('starttime', this.mondyDate).week)
      },
      getWeekInfo(type, payload) {
        /***
         * type starttime 通过日期查 week 通过周数查
         */
        for (let i = 0; i < this.weeksData.length; i++) {
          console.log(this.weeksData[i][type] + ':' + payload)
          if (this.weeksData[i][type] === payload) {
            return this.weeksData[i]
          }
        }
      },
      weekChange(ev) {
        let week = ev.val.toString()
        this.mondyDate = this.getWeekInfo('week', week).starttime
        this.initDataModel(this.mondyDate)
        this._initCourseData()
      }
    },
    mounted() {
      this.initDataModel()
      this._initWeeks()
      this._initCourseData()

    }
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
  .filter
    text-align right
    padding 20px

    & > p
      display inline-block
      font-size 14px
      color #666666
      vertical-align middle

    & > button
      border 1px solid #cccccc
      background-color #ffffff
      color #666666
      font-size 14px
      width 60px
      height 24px
      border-radius 12px
      display inline-block
      vertical-align middle

    & >>> .counter
      display inline-block
      vertical-align middle
      margin 0 10px

  .courseTableContainer
    text-align center
    position relative

    & > .outer
      width 100%

      tr
        &.week
          td
            background-color #f1f1f1

            &.active
              color #ffffff
              font-weight bold
              background-color #809dbf !important

        td
          border 1px solid #cccccc
          line-height 40px
          font-size 14px
          color #666666

          &.step
            width 80px
            vertical-align middle
            background-color #f1f1f1

          &.stepnu
            width 50px
            background-color #f1f1f1

    & > .innerBack
      display block !important

      ul.day
        li
          overflow hidden
          border none
          border-right 1px solid #eeeeee
          border-bottom 1px solid #eeeeee

    & > .innerMain
      ul.active
        //border 1px solid #004a94
        background-color #809dbf

        & *
          font-weight bold

      ul.day
        li
          overflow hidden
          position absolute
          border none
          border-right 1px solid #eeeeee
          border-bottom 1px solid #eeeeee

          &.vaild
            background-color #ffffff
            z-index 9

    & > .inner
      position absolute
      right 0
      bottom 0
      top 40px
      left 130px
      padding-top 2px

      .day
        width 14.28%
        height 100%
        overflow hidden
        position relative
        float left

        li
          width 100%
          height 8.3%
          line-height 1.5
          font-size 14px
          color #666666
          position relative

          &:first-of-type
            border-top none

          &.half
            height 8.3%

          &.vaild
            border 1px solid #809dbf
            border-radius 10px
            transition 300ms

            &:hover
              background-color #eeeeee

          .date
            line-height 1
            font-size 12px
            position absolute
            color #999999
            width 100%
            top 5px
            left 0
            right 0
            text-align center

          .kcmc
            margin-top 20px

          p
            font-size 12px
            color #999999
            height 1em
            line-height 1
            position absolute
            right 10px
            bottom 5px


</style>



// WEBPACK FOOTER //
// src/components/course/courseTable.vue